import React, { useEffect, useState } from 'react';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Avatar, Button, CircularProgress, Container, CssBaseline, Grid, Switch, TextField, Typography } from "@mui/material";
import clsx from 'clsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars/index.js";
import { browserHistory } from '../../helpers/history';
import * as LLMService from "../../services/llm.service.js";
import Api from "../../services/api";
import { Overlay } from "../../styles/global.js";
import { Styles } from '../../styles/material-styles';
import { withStyles } from '@mui/styles';
import FormRegisterChatGpt from './components/form-register-chat-gpt';
import FormRegisterGemini from './components/form-register-gemini';
import { NotificationVariant } from 'src/utils/enums/notification-variants.enum';
import { LLMType } from 'src/utils/enums/llm-type.enum';
import SimpleAutoComplete from 'src/components/auto-complete/autocomplete.js';

const LLMRegistration = (props) => {
  const { classes, intl } = props;

  const history = browserHistory;
  
  const { headerMenu, actionsHeaderMenu, userSession } = useSelector(state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
  }));
  
  const [loading, setLoading] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationVariant, setNotificationVariant] = useState('error');
  const [notificationMessage, setNotificationMessage] = useState('');

  const [llmTypes, setLLMTypes] = useState([]);
  const [llmType, setLLMType] = useState(null);
  
  if (userSession == null || userSession.user == null || userSession.user.userrole == null) {
    Api.logoff();
  }

  if (Api == null) {
    const language = props.match.params.lang;
    document.location.href=`/${language}/unavailable`;
  }
  
  const closeNotification = () => {
    setOpenNotification(false);
  };

  const showNotification = (message, variant = NotificationVariant.SUCCESS) => {
    setLoading(false);
    setOpenNotification(true);
    setNotificationVariant(variant);
    setNotificationMessage(message);
  };

  const handleChangeAutoComplete = (value) => {  
    let data = value.id > 0 ? value : null ;
    setLLMType(data);
  }

  const fetchLLMTypes = async () => {
    setLoading(true);

    try {
      const output = await LLMService.getAllLLMTypes();
      const data = output?.data ?? [];
      setLLMTypes(data);
    } catch (err) {
      showNotification("Não foi possível obter os tipos de llm.", NotificationVariant.ERROR)
    } finally {
      setLoading(false);
    }
  } 
  
  useEffect(() => {
    const bootstrap = async () => {
      await fetchLLMTypes();
    }

    bootstrap();
  }, []);
  
  return (
    <div className={classes.root}>
      <HeaderMenu />

      <main
        className={clsx(classes.content, {
          [classes.contentShift]: headerMenu.open,
        }, classes.actionsContent, {
          [classes.actionscontentShift]: actionsHeaderMenu.open,
        })}
      >
        <div className={classes.drawerHeader} />
        
        <Container component='main' maxWidth='md'>
          <CssBaseline />
          <div className={classes.paper} style={{ marginTop: 0 }}>
            <Grid container spacing={6}>
              <Grid item xs={12} sm={4}>
                <Button variant='outlined' color='primary' onClick={history.goBack}>
                  <FormattedMessage id="back" />
                </Button>
              </Grid>
              <Grid item xs={12} sm={8} />
            </Grid>

            <Avatar mt={7} style={{ backgroundColor: '#303f9f', color: 'white' }}>
              <SmartToyIcon />
            </Avatar>

            <Typography component='h1' variant='h5' mt={2}>
              {intl.formatMessage({ id: "llm.registration" })}
            </Typography>

            <div name='myForm' className={classes.form}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <SimpleAutoComplete
                    name="llmType"
                    label={intl.formatMessage({ id: "field.llm.types" })}
                    options={llmTypes}
                    stateName='llmType'
                    changeSelect={(stateName, value) => {
                      handleChangeAutoComplete(value)
                    }}
                    selected={llmType}
                    htmlOptions={true}
                  />
                </Grid>
              </Grid>
            </div>
             
            {llmType?.id === LLMType.CHATGPT && (
              <FormRegisterChatGpt
                llmType={llmType}
                onShowNotification={showNotification}
                onSetLoading={setLoading}
              />
            )}

            {llmType?.id === LLMType.GEMINI && (
              <FormRegisterGemini
                llmType={llmType}
                onShowNotification={showNotification}
                onSetLoading={setLoading}
              />
            )}
          </div>
          
          {loading && (
            <Overlay>
              <CircularProgress color='secondary' />
            </Overlay>
          )}
          
          {openNotification && (
            <CustomizedSnackbars
              variant={notificationVariant}
              message={notificationMessage}
              isOpen={openNotification}
              toClose={closeNotification}
            />
          )}          
        </Container>
      </main>
    </div>
  );
};

export default injectIntl(withStyles(Styles)(LLMRegistration));